module.exports = __webpack_public_path__ + "static/media/multiPong.8e99179e.webp";